function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.144 25.7148C36.355 25.7148 35.7154 26.3544 35.7154 27.1434V35.7149C35.7154 36.5039 35.0758 37.1435 34.2868 37.1435H5.71548C4.92648 37.1435 4.28688 36.5039 4.28688 35.7149V27.1434C4.28688 26.3544 3.64729 25.7148 2.85829 25.7148C2.06928 25.7148 1.42969 26.3544 1.42969 27.1434V35.7149C1.42969 38.0818 3.34846 40.0006 5.7154 40.0006H34.2869C36.6538 40.0006 38.5726 38.0818 38.5726 35.7149V27.1434C38.5726 26.3544 37.933 25.7148 37.144 25.7148Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.1356 27.098C27.5809 26.697 26.7016 26.697 26.147 27.098L21.431 30.626V9.64173C21.431 9.04999 20.7902 8.57031 19.9997 8.57031C19.2092 8.57031 18.5684 9.04999 18.5684 9.64173V30.6261L13.8553 27.098C13.2867 26.6869 12.3806 26.6987 11.8315 27.1243C11.2958 27.5395 11.2958 28.1977 11.8315 28.6129L18.9877 33.9698C19.546 34.3888 20.4522 34.3896 21.0119 33.9718L21.0145 33.9698L28.1707 28.6129C28.7199 28.1873 28.7042 27.509 28.1356 27.098Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
})));

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.182ba148.svg";
export { ForwardRef as ReactComponent };